import type { ReactElement } from "react";
import { useState } from "react";

import { translate } from "app/filters/i18nFilter";
import InputCell from "app/pages/sales-intelligence/modules/signals-api-webhook/components/InputCell/InputCell";
import validateUrlString from "app/pages/sales-intelligence/modules/signals-api-webhook/components/URLInputCell/utils/validate";

interface IURLInputCellProps {
    value: string;
    index: number;
    onChange: (index: number, field: "url", value: string) => void;
    onErrorChange: (error: string | null, index: number, field: "url") => void;
}

const URLInputCell = ({ value, onChange, onErrorChange, index }: IURLInputCellProps): ReactElement => {
    const [localValue, setLocalValue] = useState<string>(value);
    const [localError, setLocalError] = useState<string>("");
    const [validated, setValidated] = useState(false);

    const validate = (valueToValidate: string): boolean => {
        const isValid = valueToValidate === "" || validateUrlString(valueToValidate);
        const error = isValid ? "" : translate("si.management.saved-search-webhooks.url-error");

        setLocalError(error);
        onErrorChange(error || null, index, "url");

        return isValid;
    };

    const handleChange = (newValue: string) => {
        setLocalValue(newValue);

        if (validated) {
            validate(newValue);
        }
    };

    const handleBlur = () => {
        setValidated(true);

        if (validate(localValue) && localValue !== value) {
            onChange(index, "url", localValue);
        }
    };

    return (
        <InputCell
            error={localError}
            value={localValue}
            placeholder={translate("si.management.saved-search-webhooks.url-placeholder")}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
};

export default URLInputCell;
